module.exports = __webpack_public_path__ + "img/104.335e1a21.png";